import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AlertCircle, CheckCircle, Loader2, Mail, Send } from 'lucide-react';
import { supabase } from '../lib/supabaseClient';
import '../styles/ForgotPassword.css';

const CALLBACK_URL = `${window.location.origin}/auth/callback?type=recovery`;

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    setMessage('');

    try {
      if (!supabase) {
        setError('Supabaseが設定されていません。');
        return;
      }

      const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, { redirectTo: CALLBACK_URL });
      if (resetError) throw resetError;

      setMessage('パスワード再設定メールを送信しました。受信トレイをご確認ください。');
      window.setTimeout(() => navigate('/login', { replace: true }), 2500);
    } catch {
      setMessage('メールアドレスが登録されている場合、パスワード再設定メールを送信しました。');
      window.setTimeout(() => navigate('/login', { replace: true }), 2500);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <div className="forgot-background"></div>

      <div className="forgot-container">
        <header className="forgot-header">
          <div className="forgot-app-name">Clinical Clerkship</div>
        </header>

        <main className="forgot-card">
          <h1 className="forgot-title">パスワード再設定</h1>
          <p className="forgot-subtitle">登録済みのメールアドレスを入力してください。</p>

          {error && (
            <div className="forgot-auth-alert error" role="alert">
              <AlertCircle size={18} />
              <div>{error}</div>
            </div>
          )}

          {message && (
            <div className="forgot-auth-alert success" role="status">
              <CheckCircle size={18} />
              <div>{message}</div>
            </div>
          )}

          <form onSubmit={handleSubmit} className="forgot-form">
            <div className="forgot-form-group">
              <label htmlFor="email">
                登録済みメールアドレス
              </label>
              <div className="forgot-input-wrapper">
                <Mail className="forgot-input-icon" size={18} />
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  placeholder="university@hirosaki-u.ac.jp"
                />
              </div>
            </div>

            <button type="submit" disabled={submitting} className="forgot-submit-button">
              {submitting ? (
                <>
                  <Loader2 className="animate-spin" size={18} style={{ marginRight: 8 }} />
                  送信中...
                </>
              ) : (
                <>
                  メールを送信
                  <Send size={18} style={{ marginLeft: 8 }} />
                </>
              )}
            </button>

            <div className="forgot-links-row">
              <Link to="/login" className="forgot-back-link">
                ログイン画面に戻る
              </Link>
            </div>
          </form>
        </main>
      </div>
    </div>
  );
}

export default ForgotPassword;

